import React, { useState } from 'react';
import { Cake, Pencil } from 'lucide-react';
import toast from 'react-hot-toast';
import { apiPut } from '../../lib/api.js';

/** 'Mar 12, 1960' from a stored birthday (a UTC calendar date), or '' when missing/invalid. */
export function formatBirthday(value) {
  if (!value) return '';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { timeZone: 'UTC', year: 'numeric', month: 'short', day: 'numeric' });
}

/**
 * Birthday line on the lead profile: always visible, editable in place. A birthday is needed for
 * Birthday Drip texts to send.
 * @param {{lead: {birthday?: string}, leadId: string, onChange?: () => void}} props
 */
export default function BirthdayRow({ lead, leadId, onChange }) {
  const shown = formatBirthday(lead?.birthday);
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(shown ? new Date(lead.birthday).toISOString().slice(0, 10) : '');
  const [saving, setSaving] = useState(false);

  async function save() {
    setSaving(true);
    try {
      await apiPut(`/leads/${leadId}`, { birthday: value ? `${value}T00:00:00.000Z` : null });
      toast.success(value ? 'Birthday saved' : 'Birthday cleared');
      setEditing(false);
      onChange?.();
    } catch (e) {
      toast.error(e?.response?.data?.error || 'Could not save the birthday');
    }
    setSaving(false);
  }

  if (editing) {
    return (
      <div className="flex items-center gap-1.5 text-xs text-white/70" data-testid="birthday-row">
        <Cake className="w-3.5 h-3.5 text-white/40" />
        <input type="date" value={value} onChange={(e) => setValue(e.target.value)} aria-label="Date of birth" className="bg-civix-panelLight border border-white/10 rounded px-1.5 py-0.5 text-xs text-white" />
        <button type="button" onClick={save} disabled={saving} className="px-2 py-0.5 rounded bg-civix-purple text-white text-[11px] font-semibold disabled:opacity-50">Save</button>
        <button type="button" onClick={() => setEditing(false)} className="text-[11px] text-white/50 hover:text-white">Cancel</button>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1.5 text-xs text-white/70" data-testid="birthday-row">
      <Cake className="w-3.5 h-3.5 text-white/40" />
      <span>Birthday: {shown || <span className="text-amber-300/80">not set</span>}</span>
      <button type="button" onClick={() => setEditing(true)} aria-label="Edit birthday" className="p-0.5 text-white/40 hover:text-white"><Pencil className="w-3 h-3" /></button>
    </div>
  );
}
